import axios from 'axios';

/**
 * Axios 에러를 사용자 친화적인 메시지로 변환
 * @param error - Axios 에러 또는 일반 에러 객체
 * @returns 사용자에게 표시할 에러 메시지
 * @example
 * try {
 *   await api.post('/endpoint');
 * } catch (error) {
 *   const message = formatAxiosErrorForLog(error);
 *   setLogs(prev => prev + message);
 * }
 */
export function formatAxiosErrorForLog(error: unknown): string {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as { message?: string; detail?: string } | undefined;
    const detail = data?.message ?? data?.detail;
    if (typeof detail === 'string' && detail.trim()) {
      return detail.trim();
    }
    if (error.response?.status === 404) {
      return '요청한 리소스를 찾을 수 없습니다.';
    }
    if (error.message) {
      return error.message;
    }
    return '요청에 실패했습니다.';
  }
  if (error instanceof Error) {
    return error.message;
  }
  return '알 수 없는 오류가 발생했습니다.';
}
